const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBentleylogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-9fb87472-b3c8-4a17-ae0f-e11aa7622846",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 100,
    viewBox: "0 0 400 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-4900b7dd-3ef6-4140-ac1f-a7d42a554808"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.94,38.8c4.89-1.12,11.4-7.84,11.4-17.81,0-11.3-9.36-18.62-23.1-18.62H10.63v30.67H1.54v12.62h9.09v31.51h44.07c14.35,0,23.51-8.96,23.51-21.07,0-10.79-7.94-16.9-15.27-17.3h0ZM24.27,14.89h23.92c7.63,0,12.42,3.87,12.42,9.26s-3.87,8.96-10.18,8.96h-26.16V14.89h0Zm27.27,49.77h-27.27v-19.03h27.48c7.84,0,12.72,3.26,12.72,8.24,0,6.31-4.99,10.79-12.93,10.79h0Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.8,19.37c-16.79,0-29.92,12.52-29.92,29.41,0,20.15,15.47,29.62,30.84,29.62,11.4,0,22.08-5.7,26.77-13.84l-9.87-7.23c-3.56,5.19-8.75,8.85-16.28,8.85s-15.06-4.38-17.2-11.6h44.58v-5.19c0-18.22-12.11-30.02-28.9-30.02h0Zm-15.67,23.92c1.83-6.92,8.04-11.7,15.88-11.7s13.94,4.78,15.57,11.7h-31.45Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.2,19.37c-7.33,0-14.04,2.34-19.13,7.23v-5.6h-12.42v56.18h13.23v-33.08c0-7.23,7.23-12.52,14.35-12.52,8.04,0,13.03,4.89,13.03,12.93v32.67h13.23v-37.76c0-10.58-9.56-20.05-22.29-20.05h0Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.83 4.5 210.6 9.29 210.6 20.99 205 20.99 205 33.21 210.6 33.21 210.6 77.17 223.83 77.17 223.83 33.21 234.72 33.21 234.72 20.99 223.83 20.99 223.83 4.5 223.83 4.5",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.43 77.07 253.66 77.07 253.66 2.37 240.43 2.37 240.43 77.07 240.43 77.07",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.86,19.37c-16.79,0-29.92,12.52-29.92,29.41,0,20.15,15.47,29.62,30.84,29.62,11.4,0,22.08-5.7,26.77-13.84l-9.87-7.23c-3.56,5.19-8.75,8.85-16.28,8.85s-15.06-4.38-17.2-11.6h44.58v-5.19c0-18.22-12.11-30.02-28.9-30.02h0Zm-15.68,23.92c1.83-6.92,8.04-11.7,15.88-11.7s13.94,4.78,15.57,11.7h-31.45Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.52,20.99v31.35c0,7.23-7.23,12.62-14.35,12.62-8.04,0-13.03-4.99-13.03-12.93v-31.04h-13.23v36.03c0,10.69,10.38,20.15,24.32,20.15,6.1,0,12.42-2.65,16.79-7.53v1.43c0,8.45-6.61,14.35-16.28,14.35-6.31,0-13.94-2.04-19.44-6.21l-6.72,10.18c6.51,4.99,16.69,8.24,26.36,8.24,16.39,0,28.8-11.4,28.8-26.15V20.99h-13.23Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.85,33.38c3.79,0,6.6-2.84,6.6-6.65s-2.81-6.65-6.6-6.65-6.64,2.82-6.64,6.65,2.83,6.65,6.64,6.65h0Zm0-1.4c-3.01,0-5.26-2.23-5.26-5.24s2.25-5.29,5.26-5.29,5.24,2.25,5.24,5.29-2.23,5.24-5.24,5.24h0Zm-1.5-4.24h1.24l1.96,2.65h1.79l-2.06-2.79c.9-.34,1.5-1.29,1.5-2.3,0-1.4-.92-2.14-2.23-2.14h-3.74v7.23h1.55v-2.65h0Zm1.75-3.2c.75,0,1.12.26,1.12.78,0,.68-.37,1.04-1.12,1.04h-1.75v-1.82h1.75Z",
    style: {
      fill: "#1a1a1a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBentleylogo);
export default __webpack_public_path__ + "static/media/bentleylogo.9f4f510139b59b2b59f52aa5f8cddff4.svg";
export { ForwardRef as ReactComponent };